import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Redirect stub for former course sub-paths (permanent). Paths under
 * /courses/trauma/ belong to the hidden-until-launch trauma series, so they
 * redirect temporarily instead.
 */
export const Route = createFileRoute("/_public/courses/$")({
  beforeLoad: ({ params }) => {
    const splat = (params as { _splat?: string })._splat ?? "";
    const trauma = splat === "trauma" || splat.startsWith("trauma/");
    throw redirect({ to: "/", replace: true, statusCode: trauma ? 302 : 301 });
  },
});
